const headerNavigation = document.querySelector("[data-header-navigation]");
const headerNavigationOverlay = document.querySelector(
  "[data-header-menu-overlay]"
);

document.querySelectorAll("[data-header-menu-toggle]").forEach((el) => {
  el.addEventListener("click", () => {
    document.body.classList.toggle("overflow-hidden");

    if (headerNavigation) {
      headerNavigation.classList.toggle("-translate-x-full");
    }
    if (headerNavigationOverlay) {
      headerNavigationOverlay.classList.toggle("opacity-50");
      headerNavigationOverlay.classList.toggle("invisible");
    }
  });
});

headerNavigation.querySelectorAll("button[data-dropdown]").forEach((el) => {
  el.addEventListener("click", () => {
    el.parentNode.classList.toggle("open");
  });
});

let submenuTimer;
let activeSubmenu = null;

document.querySelectorAll(".group.top-level-link").forEach((group) => {
  const submenu = group.querySelector(".desktop-submenu");

  if (submenu) {
    const showSubmenu = () => {
      clearTimeout(submenuTimer);

      if (activeSubmenu && activeSubmenu !== submenu) {
        activeSubmenu.classList.remove(
          "xl:visible",
          "xl:opacity-100",
          "xl:block"
        );
        activeSubmenu.classList.add("xl:hidden", "xl:invisible");
      }

      activeSubmenu = submenu;

      submenu.classList.remove("xl:hidden", "xl:invisible");
      submenu.classList.add("xl:visible", "xl:opacity-100", "xl:block");
    };

    const hideSubmenu = () => {
      submenuTimer = setTimeout(() => {
        submenu.classList.remove("xl:visible", "xl:opacity-100", "xl:block");
        submenu.classList.add("xl:hidden", "xl:invisible");

        if (activeSubmenu === submenu) {
          activeSubmenu = null;
        }
      }, 500);
    };

    group.addEventListener("mouseenter", showSubmenu);
    group.addEventListener("mouseleave", hideSubmenu);
  }
});

const toggleHeaderSticky = () => {
  const sectionHeader = document.querySelector(
    ".shopify-section-group-header-group.section-header"
  );
  if (!sectionHeader) return;

  const shouldStick = window.location.pathname !== "/pages/booking";
  sectionHeader.classList.toggle("sticky", shouldStick);
  sectionHeader.classList.toggle("top-0", shouldStick);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", toggleHeaderSticky);
} else {
  toggleHeaderSticky();
}
